import { ROUTES } from '@/constants/routes';
import { ProtectedRoute } from '@/modules/Auth';
import { AppError } from '@/modules/Errors';
import { MainLayout } from '@/modules/Layout';
import {
  AiBotConfig,
  AkeneoProducts,
  Blog,
  Brands,
  Categories,
  Channels,
  CleanUpDatabase,
  ConversationDetails,
  Conversations,
  DeliverySettings,
  Faqs,
  GeneralFaqs,
  GeneralSettings,
  LinkingTool,
  Metatags,
  Pages,
  PaymentMethods,
  ProductsSync,
  Redirects,
  LLMConfig,
  LLMChannelTemplate,
  LLMTemplates,
  LLMTemplateDetails,
  Reviews,
  RobotsTxt,
  ShippingPrices,
  SignIn,
  SuggestedFaqDetails,
  SuggestedFaqs,
  UISettings,
  Variables,
  Coupons,
  Websites,
  MerchantSettings,
  PushOrders,
} from '@/pages';
import { Route, createBrowserRouter, createRoutesFromElements } from 'react-router-dom';

export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route>
      <Route path={ROUTES.SIGN_IN} element={<SignIn />} />
      <Route element={<ProtectedRoute />}>
        <Route element={<MainLayout />}>
          <Route errorElement={<AppError />}>
            <Route path={ROUTES.AI_BOT_CONFIGURATION} element={<AiBotConfig />} />
            <Route path={ROUTES.GENERAL_SETTINGS} element={<GeneralSettings />} />
            <Route path={ROUTES.UI_SETTINGS} element={<UISettings />} />
            <Route path={ROUTES.SHIPPING_PRICES} element={<ShippingPrices />} />
            <Route path={ROUTES.DELIVERY_SETTINGS} element={<DeliverySettings />} />
            <Route path={ROUTES.PAYMENT_METHODS} element={<PaymentMethods />} />
            <Route path={ROUTES.REVIEWS} element={<Reviews />} />
            <Route path={ROUTES.CHANNELS} element={<Channels />} />
            <Route path={ROUTES.ROBOTS_TXT} element={<RobotsTxt />} />
            <Route path={ROUTES.BRANDS} element={<Brands />} />
            <Route path={ROUTES.PAGES_MANAGEMENT} element={<Pages />} />
            <Route path={ROUTES.PUSH_ORDERS} element={<PushOrders />} />
            <Route path={ROUTES.COUPONS} element={<Coupons />} />
            <Route path={ROUTES.LINKING_TOOL} element={<LinkingTool />} />
            <Route path={ROUTES.MERCHANT_SETTINGS} element={<MerchantSettings />} />
            <Route path={ROUTES.METATAGS_TEMPLATES} element={<Metatags />} />
            <Route path={ROUTES.REDIRECTS} element={<Redirects />} />
            <Route path={ROUTES.LLM_CONFIG} element={<LLMConfig />} />
            <Route path={ROUTES.LLM_CHANNEL_TEMPLATE} element={<LLMChannelTemplate />} />
            <Route path={ROUTES.LLM_TEMPLATES} element={<LLMTemplates />} />
            <Route path={ROUTES.LLM_TEMPLATE_DETAILS} element={<LLMTemplateDetails />} />
            <Route path={ROUTES.VARIABLES} element={<Variables />} />
            <Route path={ROUTES.AKENEO_PRODUCTS} element={<AkeneoProducts />} />
            <Route path={ROUTES.CLEAN_UP_DATABASE} element={<CleanUpDatabase />} />
            <Route path={ROUTES.PRODUCTS_SYNC} element={<ProductsSync />} />
            <Route path={ROUTES.FAQS} element={<Faqs />} />
            <Route path={ROUTES.GENERAL_FAQS} element={<GeneralFaqs />} />
            <Route path={ROUTES.SUGGESTED_FAQS} element={<SuggestedFaqs />} />
            <Route path={ROUTES.SUGGESTED_FAQ_DETAILS} element={<SuggestedFaqDetails />} />
            <Route path={ROUTES.CATEGORIES} element={<Categories />} />
            <Route path={ROUTES.BLOG} element={<Blog />} />
            <Route path={ROUTES.WEBSITES} element={<Websites />} />
            <Route path={ROUTES.CONVERSATIONS} element={<Conversations />} />
            <Route path={ROUTES.CONVERSATION_DETAILS} element={<ConversationDetails />} />
            <Route path="*" index element={<GeneralSettings />} />
          </Route>
        </Route>
      </Route>
      <Route path="*" element={<SignIn />} />
    </Route>,
  ),
);
